export const prefix = process.env.NODE_ENV === "development" ? '' : ''
export const api = process.env.NODE_ENV === "development" ? '' : 'http://192.168.33.182:8444'
